<div style="padding: 5px">
    <input (ngModelChange)="onSearch($event)" [ngModel]="text" type="text" placeholder="Search by name...">
</div>